(function () {
  'use strict';
  var CIP = window.CIP || {};

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var fmt = CIP.moneyFormat || '${{amount}}';
    function delim(n, prec, thou, dec) {
      var parts = (n / 100).toFixed(prec).split('.');
      return parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou) + (parts[1] ? dec + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delim(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(cents, 2, "'", '.');
        default: return delim(cents, 2, ',', '.');
      }
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Header: search + mobile nav ---------- */
  function toggle(btn, panel, focusSel) {
    var open = panel.hidden;
    panel.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    if (open && focusSel) { var f = panel.querySelector(focusSel); if (f) f.focus(); }
  }
  document.addEventListener('click', function (e) {
    var s = e.target.closest('[data-search-toggle]');
    if (s) { toggle(s, document.getElementById('HeaderSearch'), 'input[type="search"]'); return; }
    var n = e.target.closest('[data-nav-open]');
    if (n) { toggle(n, document.getElementById('MobileNav')); }
  });

  /* ---------- Cart count ---------- */
  function setCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    var label = document.querySelector('[data-cart-count-label]');
    if (label) label.textContent = count ? '(' + count + ')' : '';
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');
  var scrim = document.querySelector('[data-drawer-scrim]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.hidden = false;
    document.body.classList.add('is-locked');
    setTimeout(function () { drawer.focus(); }, 50);
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.hidden = true;
    document.body.classList.remove('is-locked');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderDrawer(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    var body = drawer.querySelector('[data-drawer-items]');
    var foot = drawer.querySelector('[data-drawer-foot]');
    if (!cart.items.length) {
      body.innerHTML = '<p class="drawer__empty">Your bag is empty.</p>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (item) {
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="line__variant">' + esc(item.variant_title) + '</p>' : '';
      return '<div class="line" data-key="' + esc(item.key) + '">' +
        '<a href="' + esc(item.url) + '" class="line__media">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="line__info">' +
          '<a href="' + esc(item.url) + '" class="line__title">' + esc(item.product_title) + '</a>' + variant +
          '<div><span class="mini-qty">' +
            '<button type="button" data-line-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-line-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</span><button type="button" class="mini-remove" data-line-qty="0">Remove</button></div>' +
        '</div>' +
        '<p class="line__price mono">' + formatMoney(item.final_line_price) + '</p>' +
      '</div>';
    }).join('');
    drawer.querySelector('[data-drawer-subtotal]').textContent = formatMoney(cart.total_price);
    foot.hidden = false;
  }

  function fetchCart() {
    return fetch(CIP.routes.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function refreshDrawer() { return fetchCart().then(renderDrawer); }

  if (drawer) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) {
        if (CIP.cartDrawer && !document.body.classList.contains('tpl-cart')) {
          e.preventDefault();
          refreshDrawer().then(openDrawer);
        }
        return;
      }
      if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-scrim]')) { closeDrawer(); return; }
      var q = e.target.closest('[data-line-qty]');
      if (q && drawer.contains(q)) {
        var line = q.closest('[data-key]');
        line.style.opacity = '.5';
        fetch(CIP.routes.cartChange, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: line.getAttribute('data-key'), quantity: parseInt(q.getAttribute('data-line-qty'), 10) })
        }).then(function (r) { return r.json(); }).then(renderDrawer).catch(function () { line.style.opacity = ''; });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* ---------- Product page ---------- */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = section.querySelector('form[data-product-form], .pdp__form');
    var idInput = section.querySelector('[data-variant-id]');
    var addBtn = section.querySelector('[data-add-btn]');
    var addLabel = section.querySelector('[data-add-label]');
    var priceNow = section.querySelector('[data-price-now]');
    var priceWas = section.querySelector('[data-price-was]');
    var errorBox = section.querySelector('[data-form-error]');
    var mainWrap = section.querySelector('[data-main-media]');
    var fieldsets = section.querySelectorAll('fieldset[data-option-index]');

    function selectedOptions() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; });
      });
    }
    function showMedia(id, src, srcset) {
      if (!mainWrap) return;
      var img = mainWrap.querySelector('img');
      if (!img) return;
      if (srcset) img.srcset = srcset;
      if (src) img.src = src;
      section.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.toggle('is-active', String(t.getAttribute('data-media-id')) === String(id));
      });
    }
    function markAvailability() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('input[data-option-input]').forEach(function (input) {
          var test = opts.slice(); test[idx] = input.value;
          var match = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, i) { return o === test[i]; });
          });
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-unavailable', !match);
        });
      });
    }
    function update() {
      var opts = selectedOptions();
      fieldsets.forEach(function (fs, i) {
        var lbl = fs.querySelector('[data-option-label]');
        if (lbl) lbl.textContent = opts[i] || '';
      });
      var v = findVariant(opts);
      if (errorBox) errorBox.hidden = true;
      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      priceNow.textContent = formatMoney(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        priceWas.textContent = formatMoney(v.compare_at_price);
        priceWas.hidden = false;
      } else {
        priceWas.hidden = true;
      }
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to bag' : 'Sold out';
      if (v.featured_media) {
        var thumb = section.querySelector('[data-thumb][data-media-id="' + v.featured_media.id + '"]');
        if (thumb) showMedia(v.featured_media.id, thumb.getAttribute('data-src'), thumb.getAttribute('data-srcset'));
      }
      markAvailability();
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    section.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-input]')) update();
    });
    section.addEventListener('click', function (e) {
      var t = e.target.closest('[data-thumb]');
      if (t) { showMedia(t.getAttribute('data-media-id'), t.getAttribute('data-src'), t.getAttribute('data-srcset')); return; }
      var step = e.target.closest('[data-qty-step]');
      if (step) {
        var input = step.parentElement.querySelector('input');
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10));
        input.value = next;
      }
    });
    if (fieldsets.length) markAvailability();

    if (form && drawer && CIP.cartDrawer) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.setAttribute('aria-busy', 'true');
        if (errorBox) errorBox.hidden = true;
        fetch(CIP.routes.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) {
              if (errorBox) { errorBox.textContent = res.data.description || res.data.message || 'Could not add this item. Try another size or color.'; errorBox.hidden = false; }
              return;
            }
            return refreshDrawer().then(openDrawer);
          })
          .catch(function () { form.submit(); })
          .finally(function () { addBtn.removeAttribute('aria-busy'); });
      });
    }
  });

  /* ---------- Collection sort ---------- */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
})();
